/* eslint-disable */
import React from "react";
import $ from "jquery";
import ContactForm from "../sections/ContactForm";

const Footer = () => {
  const goToTop = () => {
    $("html, body").animate({ scrollTop: 100 }, 600);
  };
  var year = new Date().getFullYear();
  console.log(year);
  return (
    <>
      <div id="contact" className="contact">
        <svg
          preserveAspectRatio="none"
          viewBox="0 0 100 102"
          height="35"
          width="100%"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          className="svgcolor-light"
        >
          <path d="M0 0 L50 100 L100 0 Z" fill="#f7f7ff" stroke="white"></path>
        </svg>

        <div className="contact-heading animation-element">CONTACT</div>
        <div className="question animation-element">
          {"Have a question? Ping me..."}
        </div>

        <div className="form animation-element">
          <ContactForm ContactMessage={"Have a question? Ping me..."} />
        </div>
      </div>

      <div className="footer">
        <div className="">
          <a rel="noopener noreferrer" onClick={goToTop}>
            <i className="footer-arrow fas fa-angle-double-up"></i>
          </a>
        </div>
        <div className="contact-icons">
          <a
            rel="noopener noreferrer"
            id="insta"
            target="_blank"
            href="http://instagram.com"
          >
            <i className="fab icon fa-instagram"></i>
          </a>
          <a rel="noopener noreferrer" target="_blank" href="http://github.com">
            <i className="fab icon fa-github"></i>
          </a>
          <a rel="noopener noreferrer" target="_blank" href="http://gmail.com">
            <i className="far icon fa-envelope"></i>
          </a>
          <a
            rel="noopener noreferrer"
            target="_blank"
            href="http://twitter.com"
          >
            <i className="fab icon fa-twitter"></i>
          </a>
        </div>

        <div className="footnote">
          <span className="foot-name">Kartik &nbsp;</span>
          <span className="rights">&copy; {year}</span>
        </div>
      </div>
    </>
  );
};

export default Footer;
